module.exports = __webpack_public_path__ + "img/icomoon.acae53ca.svg";